import { ChangeDetectionStrategy, Component, input, output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { type NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';

export type SelectOptions<T> = SelectOption<T>[];
export type SelectOption<T> = {
  key: string;
  value: T;
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'dpqa-select',
  imports: [CommonModule, FormsModule, NzSelectModule, NgSelectModule],
  templateUrl: './select.component.html',
  styleUrl: '../multi-select/multi-select.component.less',
})
export class SelectComponent<T> {
  @ViewChild('select') private select!: NgSelectComponent;

  public value = input<NoInfer<T>>();
  public options = input<SelectOptions<T>>();
  public selectId = input.required<string>();
  public placeholder = input<string>('');
  public allowClear = input<boolean>(true);
  public panelClass = input<string>('');

  public updateValue = output<T>();
  public close = output<void>();

  handleValueChange(e: T) {
    this.updateValue.emit(e);
  }

  open() {
    this.select.open();
  }

  onClose() {
    this.close.emit();
  }

  reset() {
    this.select.clearModel();
  }
}
